import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import SEO from '../../components/SEO';
import HomepageComponents from '../../components/HomepageComponents';
import './Home.css';

const Home = () => {
  const [page, setPage] = useState(null);
  const [homepageComponents, setHomepageComponents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [pageRes, componentsRes] = await Promise.all([
          api.get('/pages/home'),
          api.get('/homepage-components'),
        ]);

        setPage(pageRes.data.page || pageRes.data);
        // Ensure components is always an array
        const components = Array.isArray(componentsRes.data)
          ? componentsRes.data
          : [];
        setHomepageComponents(components);
        setError(null);
      } catch (error) {
        console.error('Failed to fetch home data:', error);
        setError('Failed to load homepage content');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container">
        <div className="error">{error}</div>
      </div>
    );
  }

  return (
    <>
      <SEO
        title={page?.title || 'Home - Luxe Hair Salon'}
        description={page?.meta_description || 'Professional hair salon offering premium cuts, coloring, styling and treatments.'}
        keywords="hair salon, haircut, hair color, balayage, styling, beauty salon"
      />
      <div className="home-page">
        <HomepageComponents components={homepageComponents} />
      </div>
    </>
  );
};

export default Home;
